export { default } from './FieldDescription';



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/Field/FieldDescription/index.js